import { render, staticRenderFns } from "./packageDialog.vue?vue&type=template&id=5875ed70&"
import script from "./packageDialog.vue?vue&type=script&lang=js&"
export * from "./packageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports